export default __webpack_public_path__ + "static/media/death-of-a-bachelor.22139b94.jpg";